import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import { backgroundTransparentDefault } from 'common-constants/colors'
import { darkPanelButtonCss } from 'components/page/PhotoViewer/Panel/Panel.styled'

const Wrapper = styled.div`
  ${darkPanelButtonCss};
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 0 10px;

  &:hover,
  &:active {
    background-color: ${backgroundTransparentDefault};
  }
`

interface CounterProps {
  currentIndexPhoto: number
  countsPhotosAll: number
}

export const Counter: FC<CounterProps> = ({
  currentIndexPhoto,
  countsPhotosAll,
}) => {
  return (
    <Wrapper data-name="photos-counter-component">
      {currentIndexPhoto}
      &nbsp;
      <FormattedMessage id="photoviewer.counter_photo.of" defaultMessage="из" />
      &nbsp;
      {countsPhotosAll}
    </Wrapper>
  )
}
